exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-text-field__slot .theme--dark.v-label{color:hsla(0,0%,100%,.30980392156862746)!important}.v-text-field--filled .v-label,.v-text-field--full-width .v-label{top:16px!important}", ""]);

// exports
